export default "__VITE_ASSET__Co$iTWoz__"